import { render, staticRenderFns } from "./Forthstep.vue?vue&type=template&id=4bf6c9a0&scoped=true&"
import script from "./Forthstep.vue?vue&type=script&lang=js&"
export * from "./Forthstep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf6c9a0",
  null
  
)

export default component.exports